export const SLICE_NAME = "componentsReport";